// export const BASE_URL = 'https://hashedapp-api.laxstatclock.com/'; //prod
export const BASE_URL = "https://flathmann-backend.onrender.com"; //preprod

//others
// export const BASE_URL = 'http://192.168.0.101:3000/';
// WIFI
// export const BASE_URL = "http://192.168.100.7:3000/";